<template>
<div>systemSettingsView</div>
</template>

<script>
export default {
  name: 'systemSettingsView',
};
</script>

<style scoped>

</style>
